/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import {AppService} from "./app.service";
import {ToastrService} from "ngx-toastr";
import {
  NbComponentStatus,
  NbGlobalPhysicalPosition,
  NbGlobalPosition,
  NbToastrConfig,
  NbToastrService
} from "@nebular/theme";

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  config: NbToastrConfig;
  destroyByClick = true;
  duration = 4000;
  hasIcon = true;
  position: NbGlobalPosition = NbGlobalPhysicalPosition.BOTTOM_RIGHT;
  preventDuplicates = false;
  types: NbComponentStatus[] = [
    'primary',
    'success',
    'info',
    'warning',
    'danger',
  ];
  constructor(
    private analytics: AnalyticsService,
    private seoService: SeoService,
    private service: AppService,
    private toastr: ToastrService,
    private toastrService: NbToastrService,
    ) {
    this.service.showAlert.subscribe((data: {msj: string, type: 'info' | 'danger' | 'success' | 'warning' | 'primary' }) => {
      this.showAlert(data.msj, data.type);
    });
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
  }
  showAlert(msj: string, type: 'info' | 'danger' | 'success' | 'warning' | 'primary') {
    switch (type) {
      case 'info':
        this.showToast('info', 'Información', msj);
        break;
      case 'danger':
        this.showToast('danger', 'Peligro', msj);
        break;
      case 'success':
        this.showToast('success', 'Correcto', msj);
        break;
      case 'warning':
        this.showToast('warning', 'Advertencia', msj);
        break;
      case 'primary':
        this.showToast('primary', 'Notificación', msj);
        break;
    }
  }
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: this.destroyByClick,
      duration: this.duration,
      hasIcon: this.hasIcon,
      position: this.position,
      preventDuplicates: this.preventDuplicates,
    };
    const titleContent = title ? ` ${title}` : '';

    this.toastrService.show(
      body,
      `Estatus: ${titleContent}`,
      config);
  }
}
